import dateFns from 'date-fns/locale/nl';

export default {
  dateFns,

  format: {
    date: 'd-M-yyyy',
    time: 'p',
    dateTime: '$t(format:date) $t(format:time)',
    longDate: 'd MMM',
    longDateTime: "d MMMM 'om' p",
    fullDate: 'd MMM y',
    fullDateTime: "d MMMM y 'om' p",
  },

  translation: {
    common: {
      aboutPlanka: 'Over Planka',
      account: 'Account',
      actions: 'Acties',
      addAttachment_title: 'Bijlage toevoegen',
      addComment: 'Opmerking toevoegen',
      addManager_title: 'Manager toevoegen',
      addMember_title: 'Lid toevoegen',
      addUser_title: 'Gebruiker toevoegen',
      administrator: 'Beheerder',
      all: 'Alle',
      allChangesWillBeAutomaticallySavedAfterConnectionRestored:
        'Alle wijzigingen worden automatisch opgeslagen<br />nadat de verbinding is hersteld.',
      areYouSureYouWantToDeleteThisAttachment: 'Weet u zeker dat u deze bijlage wilt verwijderen?',
      areYouSureYouWantToDeleteThisBoard: 'Weet u zeker dat u dit bord wilt verwijderen?',
      areYouSureYouWantToDeleteThisCard: 'Weet u zeker dat u deze kaart wilt verwijderen?',
      areYouSureYouWantToDeleteThisComment: 'Weet u zeker dat u deze opmerking wilt verwijderen?',
      areYouSureYouWantToDeleteThisLabel: 'Weet u zeker dat u dit label wilt verwijderen?',
      areYouSureYouWantToDeleteThisList: 'Weet u zeker dat u deze lijst wilt verwijderen?',
      areYouSureYouWantToDeleteThisProject: 'Weet u zeker dat u dit project wilt verwijderen?',
      areYouSureYouWantToDeleteThisTask: 'Weet u zeker dat u deze taak wilt verwijderen?',
      areYouSureYouWantToDeleteThisUser: 'Weet u zeker dat u deze gebruiker wilt verwijderen?',
      areYouSureYouWantToLeaveBoard: 'Weet u zeker dat u het bord wilt verlaten?',
      areYouSureYouWantToLeaveProject: 'Weet u zeker dat u het project wilt verlaten?',
      areYouSureYouWantToRemoveThisManagerFromProject:
        'Weet u zeker dat u deze manager uit het project wilt verwijderen?',
      areYouSureYouWantToRemoveThisMemberFromBoard:
        'Weet u zeker dat u dit lid uit het bord wilt verwijderen?',
      attachment: 'Bijlage',
      attachments: 'Bijlagen',
      authentication: 'Authenticatie',
      background: 'Achtergrond',
      board: 'Bord',
      boardNotFound_title: 'Bord niet gevonden',
      canComment: 'Kan opmerking plaatsen',
      canEditContentOfBoard: 'Kan de inhoud van het bord bewerken.',
      canOnlyViewBoard: 'Kan alleen het bord bekijken.',
      cardActions_title: 'Kaartacties',
      cardNotFound_title: 'Kaart niet gevonden',
      cardOrActionAreDeleted: 'Kaart of actie zijn verwijderd.',
      color: 'Kleur',
      createBoard_title: 'Bord aanmaken',
      createLabel_title: 'Label aanmaken',
      createNewOneOrSelectExistingOne: 'Maak een nieuwe of selecteer een bestaande.',
      createProject_title: 'Project aanmaken',
      createTextFile_title: 'Tekstbestand aanmaken',
      currentPassword: 'Huidig wachtwoord',
      dangerZone_title: 'Gevaarlijke zone',
      date: 'Datum',
      dueDate_title: 'Vervaldatum',
      deleteAttachment_title: 'Bijlage verwijderen',
      deleteBoard_title: 'Bord verwijderen',
      deleteCard_title: 'Kaart verwijderen',
      deleteComment_title: 'Opmerking verwijderen',
      deleteLabel_title: 'Label verwijderen',
      deleteList_title: 'Lijst verwijderen',
      deleteProject_title: 'Project verwijderen',
      deleteTask_title: 'Taak verwijderen',
      deleteUser_title: 'Gebruiker verwijderen',
      description: 'Beschrijving',
      detectAutomatically: 'Automatisch detecteren',
      dropFileToUpload: 'Sleep bestand om te uploaden',
      editor: 'Editor',
      editAttachment_title: 'Bijlage bewerken',
      editAvatar_title: 'Avatar bewerken',
      editBoard_title: 'Bord bewerken',
      editDueDate_title: 'Vervaldatum bewerken',
      editEmail_title: 'E-mail bewerken',
      editInformation_title: 'Informatie bewerken',
      editLabel_title: 'Label bewerken',
      editPassword_title: 'Wachtwoord bewerken',
      editPermissions_title: 'Machtigingen bewerken',
      editStopwatch_title: 'Stopwatch bewerken',
      editUsername_title: 'Gebruikersnaam bewerken',
      email: 'E-mail',
      emailAlreadyInUse: 'E-mail is al in gebruik',
      enterCardTitle: 'Voer kaarttitel in... [Ctrl+Enter] om automatisch te openen.',
      enterDescription: 'Beschrijving invoeren...',
      enterFilename: 'Bestandsnaam invoeren',
      enterListTitle: 'Voer lijsttitel in...',
      enterProjectTitle: 'Voer projecttitel in',
      enterTaskDescription: 'Taakbeschrijving invoeren...',
      filterByLabels_title: 'Filteren op labels',
      filterByMembers_title: 'Filteren op leden',
      fromComputer_title: 'Van computer',
      fromTrello: 'Van Trello',
      general: 'Algemeen',
      hours: 'Uren',
      importBoard_title: 'Bord importeren',
      invalidCurrentPassword: 'Ongeldig huidig wachtwoord',
      labels: 'Labels',
      language: 'Taal',
      leaveBoard_title: 'Bord verlaten',
      leaveProject_title: 'Project verlaten',
      list: 'Lijst',
      listActions_title: 'Lijstacties',
      managers: 'Managers',
      members: 'Leden',
      minutes: 'Minuten',
      moveCard_title: 'Kaart verplaatsen',
      name: 'Naam',
      newEmail: 'Nieuwe e-mail',
      newPassword: 'Nieuw wachtwoord',
      newUsername: 'Nieuwe gebruikersnaam',
      noConnectionToServer: 'Geen verbinding met server',
      noBoards: 'Geen borden',
      noLists: 'Geen lijsten',
      noProjects: 'Geen projecten',
      notifications: 'Meldingen',
      noUnreadNotifications: 'Geen ongelezen meldingen.',
      openBoard_title: 'Bord openen',
      optional_inline: 'optioneel',
      organization: 'Organisatie',
      phone: 'Telefoon',
      preferences: 'Voorkeuren',
      pressPasteShortcutToAddAttachmentFromClipboard:
        'Tip: druk op Ctrl-V (Cmd-V op Mac) om een bijlage van het klembord toe te voegen.',
      project: 'Project',
      projectNotFound_title: 'Project niet gevonden',
      removeManager_title: 'Manager verwijderen',
      removeMember_title: 'Lid verwijderen',
      searchLabels: 'Labels zoeken...',
      searchMembers: 'Leden zoeken...',
      searchUsers: 'Gebruikers zoeken...',
      seconds: 'Seconden',
      selectBoard: 'Bord selecteren',
      selectList: 'Lijst selecteren',
      selectPermissions_title: 'Machtigingen selecteren',
      selectProject: 'Project selecteren',
      settings: 'Instellingen',
      stopwatch: 'Stopwatch',
      subscribeToMyOwnCardsByDefault: 'Standaard abonneren op mijn eigen kaarten',
      taskActions_title: 'Takenacties',
      tasks: 'Taken',
      thereIsNoPreviewAvailableForThisAttachment:
        'Er is geen voorbeeld beschikbaar voor deze bijlage.',
      time: 'Tijd',
      title: 'Titel',
      userActions_title: 'Gebruikersacties',
      userAddedThisCardToList: '<0>{{user}}</0><1> heeft deze kaart toegevoegd aan {{list}}</1>',
      userLeftNewCommentToCard:
        '{{user}} heeft een nieuwe opmerking achtergelaten «{{comment}}» bij <2>{{card}}</2>',
      userMovedCardFromListToList:
        '{{user}} heeft <2>{{card}}</2> verplaatst van {{fromList}} naar {{toList}}',
      userMovedThisCardFromListToList:
        '<0>{{user}}</0><1> heeft deze kaart verplaatst van {{fromList}} naar {{toList}}</1>',
      username: 'Gebruikersnaam',
      usernameAlreadyInUse: 'Gebruikersnaam is al in gebruik',
      users: 'Gebruikers',
      version: 'Versie',
      viewer: 'Kijker',
      writeComment: 'Schrijf een opmerking...',
    },

    action: {
      addAnotherCard: 'Voeg nog een kaart toe',
      addAnotherList: 'Voeg nog een lijst toe',
      addAnotherTask: 'Voeg nog een taak toe',
      addCard: 'Kaart toevoegen',
      addCard_title: 'Kaart toevoegen',
      addComment: 'Opmerking toevoegen',
      addList: 'Lijst toevoegen',
      addMember: 'Lid toevoegen',
      addMoreDetailedDescription: 'Meer gedetailleerde beschrijving toevoegen',
      addTask: 'Taak toevoegen',
      addToCard: 'Toevoegen aan kaart',
      addUser: 'Gebruiker toevoegen',
      createBoard: 'Bord aanmaken',
      createFile: 'Bestand aanmaken',
      createLabel: 'Label aanmaken',
      createNewLabel: 'Nieuw label aanmaken',
      createProject: 'Project aanmaken',
      delete: 'Verwijderen',
      deleteAttachment: 'Bijlage verwijderen',
      deleteAvatar: 'Avatar verwijderen',
      deleteBoard: 'Bord verwijderen',
      deleteCard: 'Kaart verwijderen',
      deleteCard_title: 'Kaart verwijderen',
      deleteComment: 'Opmerking verwijderen',
      deleteImage: 'Afbeelding verwijderen',
      deleteLabel: 'Label verwijderen',
      deleteList: 'Lijst verwijderen',
      deleteList_title: 'Lijst verwijderen',
      deleteNotifications: 'Dismiss all',
      deleteProject: 'Project verwijderen',
      deleteProject_title: 'Project verwijderen',
      deleteTask: 'Taak verwijderen',
      deleteTask_title: 'Taak verwijderen',
      deleteUser: 'Gebruiker verwijderen',
      edit: 'Bewerken',
      editDueDate_title: 'Vervaldatum bewerken',
      editDescription_title: 'Beschrijving bewerken',
      editEmail_title: 'E-mail bewerken',
      editInformation_title: 'Informatie bewerken',
      editPassword_title: 'Wachtwoord bewerken',
      editPermissions: 'Machtigingen bewerken',
      editStopwatch_title: 'Stopwatch bewerken',
      editTitle_title: 'Titel bewerken',
      editUsername_title: 'Gebruikersnaam bewerken',
      hideDetails: 'Details verbergen',
      import: 'Importeren',
      leaveBoard: 'Bord verlaten',
      leaveProject: 'Project verlaten',
      logOut_title: 'Uitloggen',
      makeCover_title: 'Omslag maken',
      move: 'Verplaatsen',
      moveCard_title: 'Kaart verplaatsen',
      remove: 'Verwijderen',
      removeBackground: 'Achtergrond verwijderen',
      removeCover_title: 'Omslag verwijderen',
      removeFromBoard: 'Verwijderen van bord',
      removeFromProject: 'Verwijderen van project',
      removeManager: 'Manager verwijderen',
      removeMember: 'Lid verwijderen',
      save: 'Opslaan',
      showAllAttachments: 'Alle bijlagen weergeven ({{hidden}} verbergen)',
      showDetails: 'Details weergeven',
      showFewerAttachments: 'Minder bijlagen weergeven',
      start: 'Start',
      stop: 'Stop',
      subscribe: 'Abonneren',
      unsubscribe: 'Afmelden',
      uploadNewAvatar: 'Nieuwe avatar uploaden',
      uploadNewImage: 'Nieuwe afbeelding uploaden',
    },
  },
};
